module.exports = "<span class=\"ssf-close\">\n    <span class=\"ssf-close__text\">{{ 'SHARED.CLOSE-BUTTON-TEXT' | translate }}</span>\n    <span class=\"ssf-close__icon\">\n        <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n    </span>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/close-button/close-button.component.html
// module id = 836
// module chunks = 3